import { render } from "./CARelatedPayAmount.vue?vue&type=template&id=d17b36ba"
import script from "./CARelatedPayAmount.vue?vue&type=script&lang=js"
export * from "./CARelatedPayAmount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__